// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import PayjpCheckout from 'vue-payjp-checkout'
import firebase from 'firebase'

Vue.use(PayjpCheckout)
Vue.config.productionTip = false

const config = {
  apiKey: 'AIzaSyAGHg8TZoVzGwKFy1adciVdMRl6pNZE77E',
  authDomain: 'kirarin-pcr-app.firebaseapp.com',
  projectId: 'kirarin-pcr-app',
  storageBucket: 'kirarin-pcr-app.appspot.com',
  messagingSenderId: '454861715079',
  appId: '1:454861715079:web:4695c03bdc3e123dfd6a22',
  measurementId: 'G-FKRQRETVGK'
}
firebase.initializeApp(config)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js